export enum TabNames {
  PROFILE_INFORMATION = 'profileInformation',
  MY_PROFILE = 'myProfile',
  AVATAR_AND_NICKNAME = 'avatarAndNickname',
  CHANGE_PASSWORD = 'changePassword',
}
